export const systemFieldConfig = {
    SFDC: [
      { title: "SC ID", path: "APIResponse.SCResponse.userId" },
      { title: "SFDC ID", path: "APIResponse.SFDCContactAPI.id" },
    ],
    SFDCEval: [
        { title: "SFDCEval ID", path: "APIResponse.SFDCEval.id" },
        
      ],
    AppHUB: [
      { title: "AppHUB", path: "APIResponse.transactionId1" },
      
    ],
    IDM: [
      { title: "NLP", path: "APIResponse.transactionId" },
    ],
    NGCCreateEval: [
        { title: "NGCCreateOrg", path: "APIResponse.NGCCreateOrgResponseEval" },
        { title: "NGCResponse", path: "APIResponse.NGCResponseEval.id" },
      ],
      EMS: [
        { title: "EMS", path: "APIResponse.entitlementStatus[0].eid" },
   
      ],
      NGCEnablement: [
        { title: "NGCEnablement", path: "APIResponse.Status" },
   
      ],
      NGCUpdateORG: [
        { title: "NGCUpdateORG", path: "APIResponse.NGCUpdateOrgResponse" },
   
      ],
      EMSCreate: [
        { title: "EMSCreate", path: "APIResponse.entitlementStatus[0].eid" },
   
      ],
      LGS: [
        { title: "LGS", path: "APIResponse" },
   
      ],
    
  };
  
  export const getValueFromPath = (obj, path) => {
    if (!obj || typeof path !== "string") return undefined;
  
    const parts = path.split(".");
  
    let current = obj;
  
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
  
      // Match key and optional array index like "entStatus[0]"
      const match = part.match(/^([a-zA-Z0-9_$]+)(\[(\d+)\])?$/);
  
      if (!match) return undefined;
  
      const key = match[1];
      const index = match[3];
  
      if (current === null || current === undefined || typeof current !== "object") {
        return undefined;
      }
  
      current = current[key];
  
      if (index !== undefined) {
        if (!Array.isArray(current)) return undefined;
        current = current[parseInt(index, 10)];
      }
    }
  
    return current;
  };
  
  
  